
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/ski-resorts",
      function () {
        return require("private-next-pages/[region]/ski-resorts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/ski-resorts"])
      });
    }
  